import { CSSProperties } from 'react';
import { IconType } from '.';

interface InfoProps extends IconType {
  style?: CSSProperties;
}

export default function Info({ color = '#439DED', className = '', height = 16, style, width = 16 }: InfoProps) {
  return (
    <svg width={width} height={height} style={style} className={className} viewBox="0 0 16 16">
      <path
        fill={color}
        d="M16,8a8,8,0,1,0,8,8A8,8,0,0,0,16,8Zm0,3.548A1.355,1.355,0,1,1,14.645,12.9,1.355,1.355,0,0,1,16,11.548Zm1.806,8.194a.387.387,0,0,1-.387.387H14.581a.387.387,0,0,1-.387-.387v-.774a.387.387,0,0,1,.387-.387h.387V16.516h-.387a.387.387,0,0,1-.387-.387v-.774a.387.387,0,0,1,.387-.387h2.065a.387.387,0,0,1,.387.387v3.226h.387a.387.387,0,0,1,.387.387Z"
        transform="translate(-8 -8)"
      />
    </svg>
  );
}
